import React from 'react';
import {observer} from 'mobx-react';
import configurationStore from '../../store/configuration';
import UIServicesRegistry from '@lib/ui-services/UIServicesRegistry';
import XMessageUIService from '@lib/ui-services/XMessageUIService';
import Card from '../edit-page/Card';
import store from '../../store/configuration';
import IconEdit from '../icons/IconEdit';
import IconAccept from '../icons/IconAccept';

const ConfigurationEditorGeneralInformationCard = observer(
    class ConfigurationEditorGeneralInformationCard extends React.Component {
        state = {
            marketId: 0,
            editable: []
        }

        onButtonEditClick = field => {
            var newEditable = _.xor(this.state.editable, [field.slug]);
            configurationStore.generalInformationDuringEdit = newEditable.length > 0;

            this.setState({
                editable: newEditable
            })
        }

        renderField = (field, possibleToEdit) => {
            return renderField(field, this.state.editable.includes(field.slug), possibleToEdit, this.onButtonEditClick, '', () => {
            });
        }


        constructor(props) {
            super(props)

            scheduleAtDocumentReady(() => {
                this.xMessageUIService = UIServicesRegistry.getService(XMessageUIService)
            })
        }

        UNSAFE_componentWillMount = () => {
            this.setState({
                marketSymbol: this.props.model.marketSymbol.value
            })
        }

        onNameChange = e => {
            let brand = "Cetetherm - ";
            let t = configurationStore.formModel.generalInformation.isDalkia;

            if (configurationStore.formModel.generalInformation.isDalkia.value == true) {
                brand = "Dalkia - ";
            }

            document.title = brand + e.target.value;
            configurationStore.formModel.generalInformation.name.value = e.target.value

            configurationStore.setDirty(true);
        }

        onMarketChange = e => {
            this.setState({
                marketSymbol: e.target.value
            })
            configurationStore.setDirty(true);
        }

        getSelectedMarketName = () => {
            var item = this.props.model.marketSymbol.items.filter(x => x.value == this.state.marketSymbol)[0]
            return item ? item.text : ''
        }

        onDHCustomerChange = e => {
            configurationStore.formModel.generalInformation.dhCustomer.value = e.target.value
            configurationStore.setDirty(true);
        }

        onMarketClick = e => {
            if (this.state.marketSymbol !== configurationStore.formModel.generalInformation.marketSymbol.value && configurationStore.generalInformationDuringEdit) {
                configurationStore.formModel.generalInformation.marketSymbol.value = this.state.marketSymbol
                this.xMessageUIService.pushNotification({
                    type: 'info',
                    title: __('Info'),
                    text: __('Some configuration settings and prices may be changed after changing the market'),
                    timeout: 5
                })

                store.recentlyChangedField = 'generalInformation.marketSymbol';
            }

            if (configurationStore.generalInformationDuringEdit) {
                this.props.onFormModelChange()
            }

            this.onButtonEditClick(configurationStore.formModel.generalInformation.marketSymbol)
            //configurationStore.setGeneralInformationDuringEdit(!configurationStore.generalInformationDuringEdit)
        }


        onScopeDropdownItemClick = e => {
            configurationStore.formModel.generalInformation.configurationScope.value = e.target.value;
            configurationStore.setDirty(true);
        }

        renderScopeSwitch = () => {
            let {items} = this.props.model.configurationScope || [];
            if (items.length == 0)
                return (<React.Fragment></React.Fragment>)

            return (

                <div className="configuration-editor-info-card-field">
                    <div className="configuration-editor-info-card-field-label">{__('Scope')}</div>
                    <div className="configuration-editor-info-card-field-value">
                        {this.renderScopeSwitchBody(items)}
                    </div>
                </div>
            )
        }

        renderScopeSwitchBody = (items) => {
            let selectItems = items.map(x => {
                return {
                    value: x.value,
                    text: x.text
                }
            })

            let editableMode = this.state.editable.includes(configurationStore.formModel.generalInformation.configurationScope.slug)
            let statusId = configurationStore.formModel.generalInformation.configurationScope.value;

            if (editableMode) {
                return (
                    <div style={{display: 'flex', alignItems: 'center'}}>
                        <select value={statusId} onChange={this.onScopeDropdownItemClick}>
                            {selectItems.map(item => (
                                <option key={item.value} value={item.value}>{item.text}</option>
                            ))}
                        </select>
                        <div style={{marginLeft: '5px'}}
                             onClick={() => this.onButtonEditClick(configurationStore.formModel.generalInformation.configurationScope)}>
                            <IconAccept/>
                        </div>
                    </div>

                )
            } else {
                let currentItem = items.filter(x => x.value == statusId)[0];
                if (currentItem === undefined && items.length > 0)
                    currentItem = {text: ''}
                return (
                    <div style={{display: 'flex', alignItems: 'center'}}>
                        <span>{currentItem.text}</span>
                        {configurationStore.editableMode && <div style={{marginLeft: '5px'}}
                                                                 onClick={() => this.onButtonEditClick(configurationStore.formModel.generalInformation.configurationScope)}>
                            <IconEdit/>
                        </div>}
                    </div>
                )
            }
        }

        render() {
            let {marketSymbol} = this.props.model
            return (
                <Card
                    helpInfo={configurationStore.formModel.generalInformationHelpInfo.value}
                    label="General information"
                    // editableMode={configurationStore.editableMode}
                    // editable={configurationStore.generalInformationDuringEdit}
                    className="general-info-card"
                    onEditButtonClick={() => this.onEditButtonClick()}
                >
                    <div className="configuration-editor-info-card-field">
                        <div className="configuration-editor-info-card-field-label">{__('Name')}</div>
                        <div className="configuration-editor-info-card-field-value">
                            {this.state.editable.includes(configurationStore.formModel.generalInformation.name.slug) ? (
                                <div style={{display: 'flex', alignItems: 'center'}}>
                                    <input type="text"
                                           value={configurationStore.formModel.generalInformation.name.value || ''}
                                           onChange={this.onNameChange}/>
                                    <div style={{marginLeft: '5px'}}
                                         onClick={() => this.onButtonEditClick(configurationStore.formModel.generalInformation.name)}>
                                        <IconAccept/>
                                    </div>
                                </div>
                            ) : (
                                <React.Fragment>
                                    <div style={{display: 'flex', alignItems: 'center'}}>
                                        {configurationStore.formModel.generalInformation.name.value ? (
                                            <span>{configurationStore.formModel.generalInformation.name.value}</span>
                                        ) : (
                                            <span className="text-muted">{__('None')}.</span>
                                        )}
                                        {configurationStore.editableMode && <div style={{marginLeft: '5px'}}
                                                                                 onClick={() => this.onButtonEditClick(configurationStore.formModel.generalInformation.name)}>
                                            <IconEdit/>
                                        </div>}
                                    </div>

                                </React.Fragment>
                            )}
                        </div>
                    </div>
                    <div className="configuration-editor-info-card-field">
                        <div className="configuration-editor-info-card-field-label">{__('Project')}</div>
                        <div className="configuration-editor-info-card-field-value">
                            {configurationStore.formModel.generalInformation.project.value}
                        </div>
                    </div>

                    <div className="configuration-editor-info-card-field">
                        <div className="configuration-editor-info-card-field-label">{__('Delivery address')}</div>
                        <div className="configuration-editor-info-card-field-value">
                            {this.state.editable.includes(configurationStore.formModel.generalInformation.dhCustomer.slug) ? (
                                <div style={{display: 'flex', alignItems: 'center'}}>
                                    <textarea
                                        value={configurationStore.formModel.generalInformation.dhCustomer.value || ''}
                                        onChange={this.onDHCustomerChange}></textarea>
                                    <div style={{marginLeft: '5px'}}
                                         onClick={() => this.onButtonEditClick(configurationStore.formModel.generalInformation.dhCustomer)}>
                                        <IconAccept/>
                                    </div>
                                </div>

                            ) : (
                                <div style={{display: 'flex', alignItems: 'center'}}>
                                    <span
                                        className="text-muted">{configurationStore.formModel.generalInformation.dhCustomer.value}</span>
                                    {configurationStore.editableMode && <div style={{marginLeft: '5px'}}
                                                                             onClick={() => this.onButtonEditClick(configurationStore.formModel.generalInformation.dhCustomer)}>
                                        <IconEdit/>
                                    </div>}
                                </div>
                            )}
                        </div>
                    </div>
                    <div className="configuration-editor-info-card-field">
                        <div className="configuration-editor-info-card-field-label">{__('Market')}</div>
                        <div className="configuration-editor-info-card-field-value">
                            {this.state.editable.includes(marketSymbol.slug) ? (
                                    <div style={{display: 'flex', alignItems: 'center'}}>
                                        <select value={this.state.marketSymbol} onChange={this.onMarketChange}>
                                            {marketSymbol.items.map(item => (
                                                <option key={item.value} value={item.value}>{item.text}</option>
                                            ))}
                                        </select>
                                        <div style={{marginLeft: '5px'}} onClick={() => this.onMarketClick()}>
                                            <IconAccept/>
                                        </div>
                                    </div>

                                ) :
                                <div style={{display: 'flex', alignItems: 'center'}}>
                                    <span>{this.getSelectedMarketName()}</span>
                                    <div style={{marginLeft: '5px'}}
                                         onClick={() => this.onButtonEditClick(marketSymbol)}>
                                        <IconEdit/>
                                    </div>
                                </div>

                            }
                        </div>
                    </div>
                    {this.renderScopeSwitch()}
                </Card>
            )
        }
    }
)

export default ConfigurationEditorGeneralInformationCard